import { FC, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import ScrollToTop from '@/components/shared/ScrollToTop/ScrollToTop.tsx';
import { trackPageView } from '@/utils/analytics';

const SimpleCenter: FC = () => {
  const location = useLocation();

  // Track page views on route change
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return (
    <>
      <ScrollToTop />
      <main
        id="app-main"
        className="flex flex-col grow min-h-screen justify-center items-center p-4 md:p-8 overflow-auto"
      >
        <Outlet />
      </main>
    </>
  );
};

export default SimpleCenter;
